import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-admin-company',
  templateUrl: './admin-company.component.html',
  styleUrls: ['./admin-company.component.scss']
})
export class AdminCompanyComponent implements AfterViewInit {

  @ViewChild("table", { static: false }) table: TableComponent;
  public company_uuid;
 
  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
   }

  async ngAfterViewInit() {
    this.company_uuid = await this.http.getStaticSelectedCompany();
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/company/get", data: {}},
          disabled_pagenat: false,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Name', type: 'string', key: 'name'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'Create By', type: 'string', key: 'create_by'}, 
            {label: 'Create On', type: 'date', key: 'create_on'}, 
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/admin/company/form', hide: true},
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'company', title: 'name', hide: true},
          ]}
        this.table.init(setting);
      //  this.cdr.detectChanges();
  }


}
